import { isEmpty } from '../Utils';

class ManageRostersPermissionChecker {
    hasPermission(currentUser, path) {
        if (isEmpty(currentUser)) {
            console.log('User is empty or undefined');
            return false;
        }
        console.log('Checking permissions for user:', {
            userTypeCd: currentUser.userTypeCd,
            userId: currentUser.userId,
            roles: currentUser.roles,
            permissions: currentUser.permissions,
            path : path
        });
        // Base this on the same permission logic as other management functions
        if (currentUser.userTypeCd === 'ROAD' || currentUser.userTypeCd === 'ROUS') {
            console.log('User is  ROAD || ROUS');
            return true;
        }
        console.log('User is not empty or ROAD || ROUS');
        return false; // TODO: Implement proper permission logic for non-ROAD/ROUS users based on business requirements.
    }
}
export default new ManageRostersPermissionChecker();	
